import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  IconButton,
  FormLabel,
  styled,
  Dialog,
  DialogContent,
  Button,
  Tooltip,
} from "@mui/material";
import ImageGallery from 'react-image-gallery';
import { Upload as UploadIcon, Close as CloseIcon, CloseOutlined, RotateRight, Delete, Edit, ArchiveOutlined, CancelOutlined, MoveUp } from "@mui/icons-material";
import CropperModal from "../../CropModel/CropperModal.tsx";
import Loading from "../../Loader/Loading.tsx";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const FileUploadBox = styled(Box)(({ theme }) => ({
  border: "1px dashed",
  borderColor: theme.palette.divider,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

const UploadIconBox = styled(Box)(({ theme }) => ({
  width: "48px",
  height: "48px",
  border: "1px solid",
  borderColor: theme.palette.divider,
  borderRadius: theme.shape.borderRadius,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: theme.spacing(1),
  cursor: "pointer",
}));

const FilePreviewItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: theme.palette.action.hover,
  //padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  //marginTop: theme.spacing(1),
}));

const FileIconBox = styled(Box)(({ theme }) => ({
  width: "32px",
  height: "32px",
  backgroundColor: theme.palette.action.selected,
  borderRadius: theme.shape.borderRadius,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: theme.spacing(1),
}));

interface FileUploadProps {
  section: string;
  title: string;
  clientGroup: string;
  questionId?: number; // Make questionId optional for non-question uploads
  reportDetailId?: number;
  files: any;
  onUpload: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string,
    questionId?: number,
    reportDetailId?: number
  ) => void;
  onUpdate: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string,
    index: number,
    questionId?: number,
    reportDetailId?: number
  ) => void;
  onRemove: (
    section: string,
    index: number,
    imageUrl: string,
    questionId?: number
  ) => void;

  setArchieveImages: (prev: any) => void
  setUploadedFiles: any
  reorderFile: (section: any, from: any, to: any, questionId: any) => void;
  moveinvoicetotaskphotos: (imgUrl: string) => void

}

const FileUpload: React.FC<FileUploadProps> = ({
  section,
  title,
  clientGroup,
  questionId,
  reportDetailId,
  files,
  onUpload,
  onUpdate,
  onRemove,
  setArchieveImages,
  setUploadedFiles,
  reorderFile,
  moveinvoicetotaskphotos
}) => {
  // if (section === "taskPhotos") {
  //   files = files.map((photo: any) => photo.imageUrl);
  // }
  const [bigImg, setbigImg] = useState<boolean>(false)
  const [showImg, setshowImg] = useState<any>([])
  const [showImage, setshowImage] = useState<any>('')
  const [cropperOpen, setCropperOpen] = useState<boolean>(false)
  const [cropperFile, setCropperFile] = useState<any>('');
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const [cropperIndex, setCropperIndex] = useState<number | null>(null);
  const loading = useSelector((state: any) => state.loader.isLoading);
  const images = showImg && showImg.map((img: string) => ({
    original: img,
    thumbnail: img,
  }));
  const [draggedItem, setDraggedItem] = useState<any>(null);
  const [dragOverItem, setDragOverItem] = useState<any>(null);
  const isAdmin = (localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor')


  // Add this function to handle drag and drop reordering
  const handleDragStart = (e: any, file: any, index: number) => {
    setDraggedItem({ file, index });
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e: any, file: any, index: number) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';

    if (draggedItem && draggedItem.index !== index) {
      setDragOverItem({ file, index });
    }
  };

  const handleDragEnd = () => {
    if (draggedItem && dragOverItem && section === "taskPhotos") {
      const newFiles = [...files];
      const draggedIdx = draggedItem.index;
      const dragOverIdx = dragOverItem.index;

      // Remove dragged item and insert at new position
      const [removed] = newFiles.splice(draggedIdx, 1);
      newFiles.splice(dragOverIdx, 0, removed);

      // Update display order
      const updatedFiles = newFiles.map((file, idx) => ({
        ...file,
        displayOrder: idx + 1
      }));

      setUploadedFiles((prevState: any) => ({
        ...prevState,
        taskPhotos: updatedFiles
      }));


      // Call your API or state update function here to save new order
      // Example: updateTaskPhotosOrder(updatedFiles, questionId);
      // console.log('New order:', updatedFiles);
    }
    else if (draggedItem && dragOverItem && section === "questionFiles") {
      const sourceIndex = draggedItem.index;
      const destinationIndex = dragOverItem.index;

      // Call reorderFile with correct parameters
      // For question files, questionId is passed; for other sections it's undefined
      reorderFile(section, sourceIndex, destinationIndex, questionId);
    }

    setDraggedItem(null);
    setDragOverItem(null);
  };

  const handleDragLeave = () => {
    setDragOverItem(null);
  };

  const handleFetchFile = async (file: any, index: number) => {
    const url = file;
    try {
      setCropperFile(url);
      setCropperOpen(true)
      setCropperIndex(index)
      // console.log("Image URL2 -->", objectUrl)

    } catch (error) {
      console.error("Failed to fetch file:", error);
    }
  };

  const moveImage = (from: number, to: number) => {
    if (to < 0 || to >= files.length) return;

    // Call our shared reorder function
    reorderFile(
      section,
      from,
      to,
      questionId
    );
  };


  return (
    <Box sx={{ mb: 2 }}>
      <FormLabel>{title}</FormLabel>
      <Box
        sx={{ display: "flex", flexWrap: 'wrap', gap: 2, alignItems: "flex-start", }}
        data-field={`question_${questionId}_images`}
      >
        {" "}
        {/* Flex container */}
        {/* Upload Box */}
        <FileUploadBox
          onDragOver={(e) => e.preventDefault()} // prevent browser from opening file
          // onDrop={(e) => {
          //   e.preventDefault();
          //   const files = e.dataTransfer.files;
          //   if (files && files.length > 0) {
          //     onUpload({ target: { files } }, section, questionId, reportDetailId);
          //   }
          // }}
          onDrop={(e) => {
            e.preventDefault();

            const files = Array.from(e.dataTransfer.files);

            // allow only image files
            const imageFiles = files.filter(file =>
              file.type && file.type.startsWith("image/")
            );

            if (imageFiles.length > 0) {
              onUpload(
                { target: { files: imageFiles } },
                section,
                questionId,
                reportDetailId
              );
            } else {
              alert("Only image files are allowed");
            }
          }}
          // onDrop={(e) => {
          //   e.preventDefault();

          //   const files = Array.from(e.dataTransfer.files);

          //   // ❌ reject HEIC / HEIF
          //   const validFiles = files.filter(
          //     (file) =>
          //       !file.type.includes("heic") &&
          //       !file.type.includes("heif") &&
          //       !file.name.toLowerCase().endsWith(".heic") &&
          //       !file.name.toLowerCase().endsWith(".heif")
          //   );

          //   if (validFiles.length === 0) {
          //     alert("HEIC images are not supported. Please upload jpg or png.");
          //     return;
          //   }

          //   onUpload(
          //     { target: { files: validFiles } },
          //     section,
          //     questionId,
          //     reportDetailId
          //   );
          // }}

          sx={{ flex: 1 }}>
          {" "}
          {/* Adjust width dynamically */}
          <label
            htmlFor={`file-upload-${section}-${questionId || "general"}`}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <UploadIconBox>
              <UploadIcon sx={{ color: "text.secondary" }} />
            </UploadIconBox>
            <Typography variant="body2" color="text.secondary">
              Drag/Upload Here
            </Typography>
          </label>
          <input
            type="file"
            id={`file-upload-${section}-${questionId || "general"}`}
            style={{ display: "none" }}
            multiple
            accept="image/jpeg, image/png, image/heic, image/heif"
            onChange={(e) => {
              if (e.target.files) {
                onUpload(e, section, questionId, reportDetailId)
              }
            }}
          />
        </FileUploadBox>
        {/* File Preview Section */}
        {files?.filter(Boolean).length > 0 && (
          <Stack
            direction="row"
            spacing={{ xs: 0, md: 1 }}
            sx={{ flexWrap: "wrap", alignItems: "center", gap: 2 }}
          >
            {files?.filter(Boolean)
              ?.sort((a: any, b: any) => {
                if (section === "taskPhotos" && typeof a === "object" && typeof b === "object") {
                  return (a.displayOrder || 0) - (b.displayOrder || 0);
                }
                return 0; // No sorting for other sections
              })
              .map((file: any, index: number) => {
                let imageUrl = "";
                let key = index;
                let onRemoveId = index;
                let updateId = index

                if (section === "taskPhotos" && typeof file === "object") {
                  imageUrl = file.imageUrl;
                  key = file.reportHdrImageId || index;
                  onRemoveId = file.reportHdrImageId || index;
                } else if (
                  section === "invoiceReceipt" &&
                  typeof file === "object"
                ) {
                  imageUrl = file.imageUrl;
                  key = file.reportHdrInvoiceId || index;
                  onRemoveId = file.reportHdrInvoiceId || index;
                } else {
                  imageUrl = typeof file === "string" ? file : "";
                }

                return (
                  <Box className='d-flex flex-column mb-0'
                    // draggable={section === "taskPhotos"}
                    draggable={true}
                    onDragStart={(e) => (section === "taskPhotos" || section === "questionFiles") && handleDragStart(e, file, index)}
                    onDragOver={(e) => (section === "taskPhotos" || section === "questionFiles") && handleDragOver(e, file, index)}
                    onDragEnd={handleDragEnd}
                    onDragLeave={handleDragLeave}
                    sx={{
                      cursor: (section === "taskPhotos" || section === "questionFiles") ? 'move' : 'default',
                      opacity: draggedItem?.index === index ? 0.5 : 1,
                      transform: dragOverItem?.index === index ? 'scale(1.05)' : 'scale(1)',
                      transition: 'all 0.2s ease',
                      border: dragOverItem?.index === index ? '2px solid #1976d2' : 'none',
                      borderRadius: 2,
                      padding: dragOverItem?.index === index ? '4px' : '0',
                    }}

                    gap={1}>
                    <Box
                      key={key}

                      sx={{
                        width: 150,
                        height: 125,
                        position: "relative",
                        borderRadius: 2,
                        overflow: "hidden",
                        border: "1px solid #ccc",

                      }}
                      onClick={() => {
                        // setshowImg(section === "invoiceReceipt" || section === "taskPhotos" ? files?.filter(item => item)?.map(item => item.imageUrl) : files); 
                        setshowImage(imageUrl)
                        setbigImg(true);
                      }}
                    >
                      <img
                        src={imageUrl}
                        draggable={false}
                        // alt={`preview-${key}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />

                    </Box>
                    <Box className='d-flex align-items-center justify-content-center gap-2'>
                      <IconButton
                        size="small"

                        onClick={() => {
                          const isDelete = window.confirm("Are you sure you want to delete this image ?")
                          if (isDelete) {
                            onRemove(section, onRemoveId, file, questionId)
                          }
                        }}
                      >
                        <Delete fontSize="small" />
                      </IconButton>

                      {clientGroup === "ALDI" && !isAdmin && ( <Tooltip title='Edit'>
                        <IconButton
                          className="p-1"
                          onClick={() => handleFetchFile(imageUrl, index)}
                        >
                          <Edit />
                        </IconButton>
                      </Tooltip>
                      )}

                      {clientGroup !== 'ALDI' && localStorage.getItem('liveuserRole') !== 'admin' && localStorage.getItem('liveuserRole') !== 'superadmin' && localStorage.getItem("liveuserRole") !== 'editor' && (
                        <Tooltip title='Edit'>
                          <IconButton
                            className="p-1"
                            onClick={() => handleFetchFile(imageUrl, index)}
                          >
                            <Edit />
                          </IconButton>
                        </Tooltip>
                      )}

                      {(localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor') && (
                        <>
                          <Tooltip title='Edit'>
                            <IconButton
                              className="p-1"
                              onClick={() => handleFetchFile(imageUrl, index)}
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>
                          {section === 'invoiceReceipt' && (<Tooltip title='add to taskphotos'>
                            <IconButton
                              className="p-1"
                              onClick={() => moveinvoicetotaskphotos(imageUrl)}
                            >
                              <MoveUp />
                            </IconButton>
                          </Tooltip>
                          )}
                          {(section !== 'taskPhotos' && section !== 'invoiceReceipt') && (
                            <>
                              <Tooltip title="Move Left">
                                <span>
                                  <IconButton
                                    size="small"
                                    disabled={index === 0}
                                    onClick={() => moveImage(index, index - 1)}
                                  >
                                    ⬅️
                                  </IconButton>
                                </span>
                              </Tooltip>

                              {/* Move Right */}
                              <Tooltip title="Move Right">
                                <span>
                                  <IconButton
                                    size="small"
                                    disabled={index === files.length - 1}
                                    onClick={() => moveImage(index, index + 1)}
                                  >
                                    ➡️
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </>
                          )}
                          {(section === "taskPhotos" || section === 'questionFiles') &&
                            (<Tooltip title='archive'>
                              <IconButton
                                className="p-1"
                                onClick={() => {
                                  setArchieveImages((prev) => [
                                    ...prev,
                                    { questionId: questionId, imageUrl: imageUrl }
                                  ]);
                                  onRemove(section, onRemoveId, file, questionId)
                                  toast.success("Image Archive Successfully")
                                }}
                              >
                                <ArchiveOutlined />
                              </IconButton>
                            </Tooltip>
                            )}

                        </>
                      )}

                    </Box>

                  </Box>
                );
              })}
          </Stack>
        )}

        {cropperOpen && cropperFile !== null && cropperIndex !== null && (
          <CropperModal
          open={cropperOpen}
            file={cropperFile}
            onClose={() => setCropperOpen(false)}
            onSave={(croppedFile) => {
              onUpdate(
                { target: { files: [croppedFile] } } as unknown as React.ChangeEvent<HTMLInputElement>,
                section,
                cropperIndex,
                questionId,
                reportDetailId,
              );
              setCropperOpen(false);
            }}
            reportgroup={clientGroup}
            isAdmin={isAdmin}
          />
        )}
      </Box>

      {/* <Dialog sx={{ "& .MuiDialog-paper": { background: 'transparent !important' } }} open={bigImg} onClose={() => { setbigImg(false) }}>
        <DialogContent style={{ height: '70vh', maxWidth: "100%", backgroundColor: 'transparent !important' }}>
          <Box position='relative' sx={{
            maxHeight: 'calc(50vh - 100px) !important',

            // backgroundColor: 'green',
            '.image-gallery-center': {
              backgroundColor: 'transparent',
              maxHeight: 'calc(100vh - 180px)!important',
            },
            '.image-gallery-svg': {
              color: '#ADB792'
            }
          }}>
            <IconButton
              onClick={() => setbigImg(false)}
              sx={{ position: 'absolute', top: 8, right: 8, zIndex: 10, }}
            >
              <CloseOutlined sx={{ fontSize: '48px' }} />
            </IconButton>
            <ImageGallery items={images} showPlayButton={false} />
          </Box>
        </DialogContent>
      </Dialog> */}
      <Dialog
        className="py-2 d-flex flex-column"
        sx={{ "& .MuiDialog-paper": { background: 'white !important' } }} open={bigImg} onClose={() => { setbigImg(false) }}
      >
        <Box className='d-flex align-items-center w-100 justify-content-end p-3'>
          <IconButton onClick={() => { setbigImg(false) }}><CancelOutlined sx={{ fontSize: "36px" }} /></IconButton>
        </Box>
        <Box component={'img'} src={showImage}
          flex={1}
          className="mb-2"
          // height={'100%'}
          overflow={'hidden'}
          // maxHeight={'80vh'}
          sx={{ objectFit: "conatin" }}
        />
      </Dialog>
      {loading && localStorage.getItem('liveuserRole') !== 'admin' && localStorage.getItem('liveuserRole') !== 'superadmin' && localStorage.getItem("liveuserRole") !== 'editor' && <Loading />}
    </Box>

  );
};

export default FileUpload;
